import React from 'react';
import Paragraph from './Paragraph';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Features = () => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const carouselItems = [
    {
      title: 'Increased Trust',
      description: 'The "Verified Seller" badge shows customers that your business is legitimate, increasing trust and credibility.',
      image: 'https://finditzstg.wpengine.com/wp-content/uploads/2024/11/verified-seller-carousel-img.jpg',
    },
    {
      title: 'Stand Out in Search',
      description: 'Verified businesses get priority in search results, giving you more visibility and an advantage over competitors.',
      image: 'https://finditzstg.wpengine.com/wp-content/uploads/2024/11/standout-carousel-img.jpg',
    },
    {
      title: 'Unlock Premium Features',
      description: 'Access advanced analytics, featured listings, and priority support with your verified badge.',
      image: 'https://finditzstg.wpengine.com/wp-content/uploads/2024/11/unlock-preamium-carousel-img.jpg',
    },
    {
      title: 'Lorem Ipsum Dolor 1',
      description: 'Access advanced analytics, featured listings, and priority support with your verified badge.',
      image: 'https://finditzstg.wpengine.com/wp-content/uploads/2024/11/unlock-preamium-carousel-img.jpg',
    },
    {
      title: 'Lorem Ipsum Dolor 2',
      description: 'Access advanced analytics, featured listings, and priority support with your verified badge.',
      image: 'https://finditzstg.wpengine.com/wp-content/uploads/2024/11/unlock-preamium-carousel-img.jpg',
    },
    {
      title: 'Lorem Ipsum Dolor 3',
      description: 'Access advanced analytics, featured listings, and priority support with your verified badge.',
      image: 'https://finditzstg.wpengine.com/wp-content/uploads/2024/11/unlock-preamium-carousel-img.jpg',
    },
  ];

  return (
    <div className='features-wrap'>
      <Paragraph variant="leadText" content="Here’s why you should take the next step and get your business verified:" />
      <div className='carousel-wrap'>
        <Slider {...settings}>
          {carouselItems.map((item, index) => (
            <div className="carousel-item" key={index}>
              {item.image && <img src={item.image} alt={item.title} />}
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </Slider>
        <div className="carousel-fade-overlay"></div>
      </div>
    </div>
  );
};

export default Features;
